import { NgModule } from '@angular/core';
import { PipesModule } from '../../../../pipes';

import { SharedModule } from '../../../../shared/shared.module';
import { ManagerComponentsModule } from '../../components/manager-components.module';
import { CompanyComponent } from './company.component';
import { CompanyRoutingModule } from './company.routing';
import {
	AppKeyAssociateLegalDialogComponent,
	AppKeyEditDialogComponent,
	AppKeyEditFormComponent,
	AppKeyLegalsDialogComponent,
	AppKeyLegalsTableComponent,
	AppKeyRequiredVersionsDialogComponent,
	AppKeyRequiredVersionEditDialogComponent,
	AppKeyRequiredVersionPlatformCreateDialogComponent,
	AppKeyTableComponent,
	CompanyOverviewComponent,
	LegalAppEditDialogComponent,
	LegalAppKeyAssociationDialogComponent,
	LegalAssociateAppKeyDialogComponent,
	LegalAppLocalisationComponent,
	LegalDisplayDialogComponent,
	LegalEditDialogComponent,
	LegalNewDialogComponent,
	LegalNewVersionDialogComponent,
	LegalsTableAppComponent,
	LegalAppUpdateDialogComponent,
	AppKeyNewDialogComponent
} from './components';

const components = [
	CompanyComponent,
	AppKeyAssociateLegalDialogComponent,
	AppKeyEditDialogComponent,
	AppKeyEditFormComponent,
	AppKeyLegalsDialogComponent,
	AppKeyLegalsTableComponent,
	AppKeyRequiredVersionsDialogComponent,
	AppKeyRequiredVersionEditDialogComponent,
	AppKeyRequiredVersionPlatformCreateDialogComponent,
	AppKeyNewDialogComponent,
	AppKeyTableComponent,
	CompanyOverviewComponent,
	LegalAppKeyAssociationDialogComponent,
	LegalAssociateAppKeyDialogComponent,
	LegalDisplayDialogComponent,
	LegalEditDialogComponent,
	LegalAppEditDialogComponent,
	LegalNewDialogComponent,
	LegalAppUpdateDialogComponent,
	LegalAppLocalisationComponent,
	LegalNewVersionDialogComponent,
	LegalsTableAppComponent
];

@NgModule({
	imports: [CompanyRoutingModule, SharedModule, ManagerComponentsModule, PipesModule],
	exports: [],
	declarations: [...components],
	providers: []
})
export class CompanyModule {}
